module.exports = __webpack_public_path__ + "img/product_133.41b4bec.webp";